import { useCookie, useState, useRuntimeConfig } from "#imports";
import { useInfo } from "./useLog.mjs";
export default function() {
  const { initialConsent } = useRuntimeConfig().public.multiTracker;
  const haveConsent = useState("haveConsent");
  const cookieHaveConsent = useCookie("haveConsent");
  if (!haveConsent.value) {
    if (cookieHaveConsent.value === true) {
      haveConsent.value = true;
    } else if (cookieHaveConsent.value === false) {
      haveConsent.value = false;
    } else {
      haveConsent.value = initialConsent;
      cookieHaveConsent.value = initialConsent;
    }
  }
  const grantConsent = () => {
    haveConsent.value = true;
    cookieHaveConsent.value = true;
    useInfo("consent granted.");
  };
  const revokeConsent = () => {
    haveConsent.value = false;
    cookieHaveConsent.value = false;
    useInfo("consent revoked.");
  };
  return {
    haveConsent,
    revokeConsent,
    grantConsent
  };
}
